import PropTypes from 'prop-types';
import { markdownNode } from './markdown-node';

export const edges = PropTypes.arrayOf(
    PropTypes.shape({
        node: markdownNode,
    }).isRequired,
).isRequired;
